import { LocalStorageFacade } from "paliari-js-utils"
import apiInfo from "@/api/apiInfo"

const KEY = "apiInfo"

export default {
  async fetchInfo() {
    const info = await apiInfo.info()
    this.setInfo(info)
  },

  getInfo() {
    if (!LocalStorageFacade.getItem(KEY)) {
      this.fetchInfo()
    }
    return LocalStorageFacade.getItem(KEY)
  },

  setInfo(info) {
    LocalStorageFacade.setItem(KEY, info)
  },

  remove() {
    LocalStorageFacade.removeItem(KEY)
  },
}
